import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function coApplicantDataReducer(state = initialState.coApplicantData, action) {
  switch (action.type) {
    case types.LOAD_CO_APPLICANT_DATA_SUCCESS:
      return action.coApplicantData;
    default:
      return state;
  }
}
